import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type Maybe<T> = T | null;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string,
  String: string,
  Boolean: boolean,
  Int: number,
  Float: number,
  AWSTimestamp: any,
  _FieldSet: any,
};







export type CreateFriendInput = {
  userId: Scalars['ID'],
  friendId: Scalars['ID'],
};

export type CreateOnlineStatusInput = {
  ttl?: Maybe<Scalars['Int']>,
};

export type CreateUserInput = {
  id: Scalars['ID'],
  username: Scalars['String'],
};

export type DeleteUserInput = {
  id: Scalars['ID'],
};

export type Friend = {
  userID: Scalars['ID'],
  friendID: Scalars['ID'],
};

export type FriendPayload = {
  user1: User,
  user2: User,
};

export type Mutation = {
  createUser?: Maybe<User>,
  updateUser?: Maybe<User>,
  deleteUser?: Maybe<User>,
  createOnlineStatus?: Maybe<OnlineStatus>,
  createFriend?: Maybe<FriendPayload>,
  updateUserAvatar?: Maybe<User>,
};


export type MutationCreateUserArgs = {
  input: CreateUserInput
};


export type MutationUpdateUserArgs = {
  input: UpdateUserInput
};


export type MutationDeleteUserArgs = {
  input: DeleteUserInput
};


export type MutationCreateOnlineStatusArgs = {
  userID?: Maybe<Scalars['ID']>,
  ttl?: Maybe<Scalars['Int']>
};


export type MutationCreateFriendArgs = {
  input: CreateFriendInput
};


export type MutationUpdateUserAvatarArgs = {
  input: UpdateUserAvatarInput
};

export type OnlineStatus = {
  id: Scalars['ID'],
  ttl?: Maybe<Scalars['AWSTimestamp']>,
  online: Scalars['Boolean'],
  until?: Maybe<Scalars['String']>,
};

export type OnlineStatusConnection = {
  items?: Maybe<Array<Maybe<OnlineStatus>>>,
  nextToken?: Maybe<Scalars['String']>,
};

export type Query = {
  getUser?: Maybe<User>,
  listUsers?: Maybe<UserConnection>,
  me?: Maybe<User>,
  getOnlineStatus?: Maybe<OnlineStatus>,
  listOnlineStatuses?: Maybe<OnlineStatusConnection>,
  getFriends?: Maybe<Array<User>>,
};


export type QueryGetUserArgs = {
  id: Scalars['ID']
};


export type QueryListUsersArgs = {
  filter?: Maybe<TableUserFilterInput>,
  limit?: Maybe<Scalars['Int']>,
  nextToken?: Maybe<Scalars['String']>
};


export type QueryGetOnlineStatusArgs = {
  userID?: Maybe<Scalars['ID']>
};


export type QueryListOnlineStatusesArgs = {
  filter?: Maybe<TableOnlineStatusFilterInput>,
  limit?: Maybe<Scalars['Int']>,
  nextToken?: Maybe<Scalars['String']>
};


export type QueryGetFriendsArgs = {
  userId: Scalars['ID']
};

export type S3Object = {
  bucket: Scalars['String'],
  region: Scalars['String'],
  key: Scalars['String'],
};

export type S3ObjectInput = {
  bucket: Scalars['String'],
  region: Scalars['String'],
  localUri?: Maybe<Scalars['String']>,
  visibility?: Maybe<Visibility>,
  key?: Maybe<Scalars['String']>,
  mimeType?: Maybe<Scalars['String']>,
};

export type Subscription = {
  onCreateUser?: Maybe<User>,
  onUpdateUser?: Maybe<User>,
  onDeleteUser?: Maybe<User>,
  onCreateOnlineStatus?: Maybe<OnlineStatus>,
};


export type SubscriptionOnCreateUserArgs = {
  id?: Maybe<Scalars['ID']>,
  username?: Maybe<Scalars['String']>
};


export type SubscriptionOnUpdateUserArgs = {
  id?: Maybe<Scalars['ID']>,
  username?: Maybe<Scalars['String']>
};


export type SubscriptionOnDeleteUserArgs = {
  id?: Maybe<Scalars['ID']>,
  username?: Maybe<Scalars['String']>
};


export type SubscriptionOnCreateOnlineStatusArgs = {
  id: Scalars['ID']
};

export type TableBooleanFilterInput = {
  ne?: Maybe<Scalars['Boolean']>,
  eq?: Maybe<Scalars['Boolean']>,
};

export type TableFloatFilterInput = {
  ne?: Maybe<Scalars['Float']>,
  eq?: Maybe<Scalars['Float']>,
  le?: Maybe<Scalars['Float']>,
  lt?: Maybe<Scalars['Float']>,
  ge?: Maybe<Scalars['Float']>,
  gt?: Maybe<Scalars['Float']>,
  contains?: Maybe<Scalars['Float']>,
  notContains?: Maybe<Scalars['Float']>,
  between?: Maybe<Array<Maybe<Scalars['Float']>>>,
};

export type TableFriendFilterInput = {
  userId?: Maybe<TableIdFilterInput>,
  friendId?: Maybe<TableIdFilterInput>,
};

export type TableIdFilterInput = {
  ne?: Maybe<Scalars['ID']>,
  eq?: Maybe<Scalars['ID']>,
  le?: Maybe<Scalars['ID']>,
  lt?: Maybe<Scalars['ID']>,
  ge?: Maybe<Scalars['ID']>,
  gt?: Maybe<Scalars['ID']>,
  contains?: Maybe<Scalars['ID']>,
  notContains?: Maybe<Scalars['ID']>,
  between?: Maybe<Array<Maybe<Scalars['ID']>>>,
  beginsWith?: Maybe<Scalars['ID']>,
};

export type TableIntFilterInput = {
  ne?: Maybe<Scalars['Int']>,
  eq?: Maybe<Scalars['Int']>,
  le?: Maybe<Scalars['Int']>,
  lt?: Maybe<Scalars['Int']>,
  ge?: Maybe<Scalars['Int']>,
  gt?: Maybe<Scalars['Int']>,
  contains?: Maybe<Scalars['Int']>,
  notContains?: Maybe<Scalars['Int']>,
  between?: Maybe<Array<Maybe<Scalars['Int']>>>,
};

export type TableOnlineStatusFilterInput = {
  userID?: Maybe<TableIdFilterInput>,
  ttl?: Maybe<TableIntFilterInput>,
};

export type TableStringFilterInput = {
  ne?: Maybe<Scalars['String']>,
  eq?: Maybe<Scalars['String']>,
  le?: Maybe<Scalars['String']>,
  lt?: Maybe<Scalars['String']>,
  ge?: Maybe<Scalars['String']>,
  gt?: Maybe<Scalars['String']>,
  contains?: Maybe<Scalars['String']>,
  notContains?: Maybe<Scalars['String']>,
  between?: Maybe<Array<Maybe<Scalars['String']>>>,
  beginsWith?: Maybe<Scalars['String']>,
};

export type TableUserFilterInput = {
  id?: Maybe<TableIdFilterInput>,
  username?: Maybe<TableStringFilterInput>,
};

export type UpdateUserAvatarInput = {
  id?: Maybe<Scalars['ID']>,
  file: S3ObjectInput,
};

export type UpdateUserInput = {
  id: Scalars['ID'],
  username?: Maybe<Scalars['String']>,
};

export type User = {
  id: Scalars['ID'],
  username: Scalars['String'],
  friends?: Maybe<Array<User>>,
  online?: Maybe<Scalars['Boolean']>,
  avatar: Scalars['String'],
};

export type UserConnection = {
  items?: Maybe<Array<Maybe<User>>>,
  nextToken?: Maybe<Scalars['String']>,
};

export enum Visibility {
  Public = 'public',
  Private = 'private'
}

export type CreateOnlineHeartbeatMutationVariables = {
  userID: Scalars['ID']
};


export type CreateOnlineHeartbeatMutation = { createOnlineStatus: Maybe<Pick<OnlineStatus, 'id' | 'online' | 'until'>> };

export type DeleteOnlineHeartbeatMutationVariables = {
  userID: Scalars['ID']
};


export type DeleteOnlineHeartbeatMutation = { createOnlineStatus: Maybe<Pick<OnlineStatus, 'id' | 'online' | 'until'>> };

export type ToggleOnlineHeartbeatMutationVariables = {
  userID: Scalars['ID'],
  ttl?: Maybe<Scalars['Int']>
};


export type ToggleOnlineHeartbeatMutation = { createOnlineStatus: Maybe<Pick<OnlineStatus, 'id' | 'online' | 'until'>> };

export type UpdateUserAvatarMutationVariables = {
  input: UpdateUserAvatarInput
};


export type UpdateUserAvatarMutation = { updateUserAvatar: Maybe<Pick<User, 'id' | 'avatar'>> };

export type GetMeQueryVariables = {};


export type GetMeQuery = { me: Maybe<Pick<User, 'id' | 'username' | 'avatar'>> };

export type GetOnlineStatusQueryVariables = {};


export type GetOnlineStatusQuery = { getOnlineStatus: Maybe<Pick<OnlineStatus, 'id' | 'online' | 'until'>> };

export type GetFriendsQueryVariables = {};


export type GetFriendsQuery = { me: Maybe<(
    Pick<User, 'id'>
    & { friends: Maybe<Array<Pick<User, 'id' | 'username' | 'online' | 'avatar'>>> }
  )> };

export type ListenToHeartbeatSubscriptionVariables = {
  userID: Scalars['ID']
};


export type ListenToHeartbeatSubscription = { onCreateOnlineStatus: Maybe<Pick<OnlineStatus, 'id' | 'online' | 'until'>> };


export const CreateOnlineHeartbeatDocument = gql`
    mutation CreateOnlineHeartbeat($userID: ID!) {
  createOnlineStatus(userID: $userID) {
    id
    online
    until
  }
}
    `;
export type CreateOnlineHeartbeatMutationFn = ApolloReactCommon.MutationFunction<CreateOnlineHeartbeatMutation, CreateOnlineHeartbeatMutationVariables>;

/**
 * __useCreateOnlineHeartbeatMutation__
 *
 * To run a mutation, you first call `useCreateOnlineHeartbeatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOnlineHeartbeatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOnlineHeartbeatMutation, { data, loading, error }] = useCreateOnlineHeartbeatMutation({
 *   variables: {
 *      userID: // value for 'userID'
 *   },
 * });
 */
export function useCreateOnlineHeartbeatMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateOnlineHeartbeatMutation, CreateOnlineHeartbeatMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateOnlineHeartbeatMutation, CreateOnlineHeartbeatMutationVariables>(CreateOnlineHeartbeatDocument, baseOptions);
      }
export type CreateOnlineHeartbeatMutationHookResult = ReturnType<typeof useCreateOnlineHeartbeatMutation>;
export type CreateOnlineHeartbeatMutationResult = ApolloReactCommon.MutationResult<CreateOnlineHeartbeatMutation>;
export type CreateOnlineHeartbeatMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateOnlineHeartbeatMutation, CreateOnlineHeartbeatMutationVariables>;
export const DeleteOnlineHeartbeatDocument = gql`
    mutation DeleteOnlineHeartbeat($userID: ID!) {
  createOnlineStatus(userID: $userID, ttl: 0) {
    id
    online
    until
  }
}
    `;
export type DeleteOnlineHeartbeatMutationFn = ApolloReactCommon.MutationFunction<DeleteOnlineHeartbeatMutation, DeleteOnlineHeartbeatMutationVariables>;

/**
 * __useDeleteOnlineHeartbeatMutation__
 *
 * To run a mutation, you first call `useDeleteOnlineHeartbeatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOnlineHeartbeatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOnlineHeartbeatMutation, { data, loading, error }] = useDeleteOnlineHeartbeatMutation({
 *   variables: {
 *      userID: // value for 'userID'
 *   },
 * });
 */
export function useDeleteOnlineHeartbeatMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteOnlineHeartbeatMutation, DeleteOnlineHeartbeatMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteOnlineHeartbeatMutation, DeleteOnlineHeartbeatMutationVariables>(DeleteOnlineHeartbeatDocument, baseOptions);
      }
export type DeleteOnlineHeartbeatMutationHookResult = ReturnType<typeof useDeleteOnlineHeartbeatMutation>;
export type DeleteOnlineHeartbeatMutationResult = ApolloReactCommon.MutationResult<DeleteOnlineHeartbeatMutation>;
export type DeleteOnlineHeartbeatMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteOnlineHeartbeatMutation, DeleteOnlineHeartbeatMutationVariables>;
export const ToggleOnlineHeartbeatDocument = gql`
    mutation ToggleOnlineHeartbeat($userID: ID!, $ttl: Int) {
  createOnlineStatus(userID: $userID, ttl: $ttl) {
    id
    online
    until
  }
}
    `;
export type ToggleOnlineHeartbeatMutationFn = ApolloReactCommon.MutationFunction<ToggleOnlineHeartbeatMutation, ToggleOnlineHeartbeatMutationVariables>;

/**
 * __useToggleOnlineHeartbeatMutation__
 *
 * To run a mutation, you first call `useToggleOnlineHeartbeatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleOnlineHeartbeatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleOnlineHeartbeatMutation, { data, loading, error }] = useToggleOnlineHeartbeatMutation({
 *   variables: {
 *      userID: // value for 'userID'
 *      ttl: // value for 'ttl'
 *   },
 * });
 */
export function useToggleOnlineHeartbeatMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ToggleOnlineHeartbeatMutation, ToggleOnlineHeartbeatMutationVariables>) {
        return ApolloReactHooks.useMutation<ToggleOnlineHeartbeatMutation, ToggleOnlineHeartbeatMutationVariables>(ToggleOnlineHeartbeatDocument, baseOptions);
      }
export type ToggleOnlineHeartbeatMutationHookResult = ReturnType<typeof useToggleOnlineHeartbeatMutation>;
export type ToggleOnlineHeartbeatMutationResult = ApolloReactCommon.MutationResult<ToggleOnlineHeartbeatMutation>;
export type ToggleOnlineHeartbeatMutationOptions = ApolloReactCommon.BaseMutationOptions<ToggleOnlineHeartbeatMutation, ToggleOnlineHeartbeatMutationVariables>;
export const UpdateUserAvatarDocument = gql`
    mutation UpdateUserAvatar($input: UpdateUserAvatarInput!) {
  updateUserAvatar(input: $input) {
    id
    avatar
  }
}
    `;
export type UpdateUserAvatarMutationFn = ApolloReactCommon.MutationFunction<UpdateUserAvatarMutation, UpdateUserAvatarMutationVariables>;

/**
 * __useUpdateUserAvatarMutation__
 *
 * To run a mutation, you first call `useUpdateUserAvatarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserAvatarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserAvatarMutation, { data, loading, error }] = useUpdateUserAvatarMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserAvatarMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateUserAvatarMutation, UpdateUserAvatarMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateUserAvatarMutation, UpdateUserAvatarMutationVariables>(UpdateUserAvatarDocument, baseOptions);
      }
export type UpdateUserAvatarMutationHookResult = ReturnType<typeof useUpdateUserAvatarMutation>;
export type UpdateUserAvatarMutationResult = ApolloReactCommon.MutationResult<UpdateUserAvatarMutation>;
export type UpdateUserAvatarMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateUserAvatarMutation, UpdateUserAvatarMutationVariables>;
export const GetMeDocument = gql`
    query GetMe {
  me {
    id
    username
    avatar
  }
}
    `;

/**
 * __useGetMeQuery__
 *
 * To run a query within a React component, call `useGetMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMeQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMeQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetMeQuery, GetMeQueryVariables>) {
        return ApolloReactHooks.useQuery<GetMeQuery, GetMeQueryVariables>(GetMeDocument, baseOptions);
      }
export function useGetMeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMeQuery, GetMeQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetMeQuery, GetMeQueryVariables>(GetMeDocument, baseOptions);
        }
export type GetMeQueryHookResult = ReturnType<typeof useGetMeQuery>;
export type GetMeLazyQueryHookResult = ReturnType<typeof useGetMeLazyQuery>;
export type GetMeQueryResult = ApolloReactCommon.QueryResult<GetMeQuery, GetMeQueryVariables>;
export const GetOnlineStatusDocument = gql`
    query GetOnlineStatus {
  getOnlineStatus {
    id
    online
    until
  }
}
    `;

/**
 * __useGetOnlineStatusQuery__
 *
 * To run a query within a React component, call `useGetOnlineStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOnlineStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOnlineStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOnlineStatusQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetOnlineStatusQuery, GetOnlineStatusQueryVariables>) {
        return ApolloReactHooks.useQuery<GetOnlineStatusQuery, GetOnlineStatusQueryVariables>(GetOnlineStatusDocument, baseOptions);
      }
export function useGetOnlineStatusLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetOnlineStatusQuery, GetOnlineStatusQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetOnlineStatusQuery, GetOnlineStatusQueryVariables>(GetOnlineStatusDocument, baseOptions);
        }
export type GetOnlineStatusQueryHookResult = ReturnType<typeof useGetOnlineStatusQuery>;
export type GetOnlineStatusLazyQueryHookResult = ReturnType<typeof useGetOnlineStatusLazyQuery>;
export type GetOnlineStatusQueryResult = ApolloReactCommon.QueryResult<GetOnlineStatusQuery, GetOnlineStatusQueryVariables>;
export const GetFriendsDocument = gql`
    query GetFriends {
  me {
    id
    friends {
      id
      username
      online
      avatar
    }
  }
}
    `;

/**
 * __useGetFriendsQuery__
 *
 * To run a query within a React component, call `useGetFriendsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFriendsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFriendsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFriendsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetFriendsQuery, GetFriendsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetFriendsQuery, GetFriendsQueryVariables>(GetFriendsDocument, baseOptions);
      }
export function useGetFriendsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetFriendsQuery, GetFriendsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetFriendsQuery, GetFriendsQueryVariables>(GetFriendsDocument, baseOptions);
        }
export type GetFriendsQueryHookResult = ReturnType<typeof useGetFriendsQuery>;
export type GetFriendsLazyQueryHookResult = ReturnType<typeof useGetFriendsLazyQuery>;
export type GetFriendsQueryResult = ApolloReactCommon.QueryResult<GetFriendsQuery, GetFriendsQueryVariables>;
export const ListenToHeartbeatDocument = gql`
    subscription ListenToHeartbeat($userID: ID!) {
  onCreateOnlineStatus(id: $userID) {
    id
    online
    until
  }
}
    `;

/**
 * __useListenToHeartbeatSubscription__
 *
 * To run a query within a React component, call `useListenToHeartbeatSubscription` and pass it any options that fit your needs.
 * When your component renders, `useListenToHeartbeatSubscription` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListenToHeartbeatSubscription({
 *   variables: {
 *      userID: // value for 'userID'
 *   },
 * });
 */
export function useListenToHeartbeatSubscription(baseOptions?: ApolloReactHooks.SubscriptionHookOptions<ListenToHeartbeatSubscription, ListenToHeartbeatSubscriptionVariables>) {
        return ApolloReactHooks.useSubscription<ListenToHeartbeatSubscription, ListenToHeartbeatSubscriptionVariables>(ListenToHeartbeatDocument, baseOptions);
      }
export type ListenToHeartbeatSubscriptionHookResult = ReturnType<typeof useListenToHeartbeatSubscription>;
export type ListenToHeartbeatSubscriptionResult = ApolloReactCommon.SubscriptionResult<ListenToHeartbeatSubscription>;